const TESTIMONIALS = [
  {
    avatar: "/images/testimonials/aman.avif",
    name: "Aman",
    duration: "9 months on Airbnb",
    rating: 5,
    date: "February 2025",
    body: "The stay was amazing. The caretakers made a delicious breakfast, the best food we had in Goa. The owner also checked in multiple times to ensure we had no issues. A wonderful experience!"
  },
  {
    avatar: "/images/testimonials/sonali.avif",
    name: "Sonali",
    duration: "5 years on Airbnb",
    rating: 5,
    date: "February 2025",
    body: "Spacious, clean, and homely! Close to the beach and shops. Mulayam made great breakfasts and took good care of us. The host was very responsive. The pool was an added bonus!"
  },
  {
    avatar: "/images/testimonials/nilesh.avif",
    name: "Nilesh",
    location: "Gurgaon, India",
    rating: 5,
    date: "December 2024",
    body: "One of the best villas we have stayed in. The caretaker was excellent, the rooms were clean and spacious, and many cafés were within walking distance. Highly recommended!"
  },
  {
    avatar: "/images/testimonials/robin.png",
    name: "Robin",
    duration: "11 years on Airbnb",
    rating: 5,
    date: "December 2024",
    body: "Amazing stay, friendly host, and a perfect location! The villa was stunning, and we loved every moment. We’ll definitely return for another stay. Highly recommend this place!"
  },
  {
    avatar: "/images/testimonials/aayush.avif",
    name: "Aayush",
    duration: "3 years on Airbnb",
    rating: 5,
    date: "October 2024",
    body: "The villa looked even better than the photos. Some spaces weren’t even shown but were clean and well-maintained. The caretaker, Mulayam Bhaiya, was helpful and made amazing breakfast!"
  },
  {
    avatar: "/images/testimonials/adarsh.avif",
    name: "Adarsh",
    duration: "3 years on Airbnb",
    rating: 5,
    date: "September 2024",
    body: "Rehan was an amazing host. The villa was much better than the photos! Mulayam ensured everything was clean and taken care of. The location was perfect. We had a smooth stay!"
  }
];

export default TESTIMONIALS;